$(function () {
    if (!$('.related-games-container').length) return;

    $('#carousel-related-games').carousel({
        interval: false
    });

    //Clone related items to gain the desired effect
    // $('#carousel-related-games .item').each(function () {
        // var $this = $(this),
            // $next = $this.next(),
            // panelContainerClasses = "left-panel-container center-panel-container right-panel-container";

        // if (!$next.length) {
            // $next = $this.siblings(':first');
        // }

        // $this.children(':first-child').removeClass(panelContainerClasses).addClass('left-panel-container');

        // $next.children(':first-child').clone().appendTo($this).removeClass(panelContainerClasses).addClass('center-panel-container');

        // if ($next.next().length > 0) {
            // $next.next().children(':first-child').clone().appendTo($this).removeClass(panelContainerClasses).addClass('right-panel-container');
        // }
        // else {
            // $this.siblings(':first').children(':first-child').clone().appendTo($this).removeClass(panelContainerClasses).addClass('right-panel-container');
        // }
    // });

    // $('#carousel-related-games').on('slide.bs.carousel', function (e) {
    //     var $activeItem = $('.active'),
    //         $nextActiveItem;

    //     if (e.direction === 'left') {
    //         //left = sliding to the right
    //         var $next = $activeItem.next();
    //         if (!$next.length) {
    //             $next = $activeItem.siblings(':first');
    //         }
    //         $nextActiveItem = $next;
    //     } else {
    //         //right = sliding to the left
    //         var $prev = $activeItem.prev();
    //         if (!$prev.length) {
    //             $prev = $activeItem.siblings(':last');
    //         }
    //         $nextActiveItem = $prev;
    //     }

    //     $activeItem.addClass('transition-item-out');
    //     $nextActiveItem.addClass('transition-item-in');

    //     setTimeout(() => {
    //         $('.transition-item-out, .transition-item-in').removeClass('transition-item-out transition-item-in');
    //     }, 600);

    // });

});


// WEBPACK FOOTER //
// ./features/related-games/related-games.js